import ContentMAPI from "@/app/api/content-management/content-management"
import { useEffect, useState } from "react"
import { useGlobalContext } from "@/global/GlobalContext"
import GeneralLayout from "@/layouts/General"
import { LoadButton } from "@/components/Button"
import { EventCards } from "@/components/event-card/EventCard"
import EventCardSkeleton from "@/components/skeletons/EventCardSkeleton"
import CenteredHero from "@/components/CenteredHero"
const contentMApi = new ContentMAPI()

const Blog = () => {
  const { notifyError, pathname } = useGlobalContext()
  const [onReq, setOnReq] = useState(true)
  const [blogs, setBlogs] = useState([])
  const [currBlogs, setCurrBlogs] = useState([])
  const [page, setPage] = useState(1)
  const [hideLoadMoreBtn, setHideLoadMoreBtn] = useState(true)
  const [tempBlogsL, setTempBlogsL] = useState(0)
  const limit = 10

  useEffect(() => {
    loadBlogs()
  }, [])

  useEffect(() => {
    if (blogs.length > currBlogs.length) {
      setCurrBlogs(blogs)
    }

    handleLoadMoreBtn()
  }, [blogs])

  useEffect(() => {
    if (page > 1) loadBlogs()
  }, [page])

  const loadMoreBlogs = () => {
    setPage(page + 1)
  }

  const handleLoadMoreBtn = () => {
    setHideLoadMoreBtn(blogs.length < limit)
  }

  // API request
  const loadBlogs = async () => {
    setOnReq(true)
    try {
      let params = {
        page: page,
        limit: limit,
      }
      const { data } = await contentMApi.getBlogs(params)
      setTempBlogsL(data.data.blogs.length)

      if (page > 1) {
        setBlogs(currBlogs.concat(data.data.blogs))
      } else {
        setBlogs(data.data.blogs)
      }
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
  }

  return (
    <GeneralLayout bgColor="bg-white" isFixed={false}>
      <CenteredHero title="Blogs" custCls="bg-[url('/src/assets/imgs/cultural-event/banner.jpeg')] h-[60vh]" />
      <section className="w-full bg-[url('/src/assets/imgs/cultural-event/section-cover.webp')] bg-cover no-repeat bg-center py-10 sm:py-20 px-6 sm:px-12">
        {onReq ? (
          currBlogs.length <= 0 ?
            <EventCardSkeleton />
            :
            <EventCards events={currBlogs} onReq={onReq} pathname={pathname} />
        ) : (
          currBlogs?.length > 0 ?
            <EventCards events={currBlogs} onReq={onReq} pathname={pathname} />
            :
            <p className="text-center text-gray-500">No blog available.</p>
        )}
        {(!hideLoadMoreBtn && tempBlogsL >= limit) && (
          <div className="py-8 text-center">
            <LoadButton onClickBtn={loadMoreBlogs} />
          </div>
        )}
      </section>
    </GeneralLayout>
  )
}

export default Blog